import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import TextCSS from '../Text/Styles';

const Button = ({
  buttonRef,
  disabled,
  isTextOnly,
  type,
  style,
  text,
  backgroundColor,
  backgroundColorOnHover,
  textColor,
  borderWidth,
  borderColor,
  showHoverBg,
  onClick,
  children,
}) => {
  return (
    <StyledButton
      ref={buttonRef}
      disabled={disabled}
      type={type}
      style={style}
      backgroundColor={backgroundColor}
      backgroundColorOnHover={backgroundColorOnHover}
      textColor={textColor}
      borderWidth={borderWidth}
      borderColor={borderColor}
      showHoverBg={showHoverBg}
      onClick={onClick}
    >
      {isTextOnly ? text : children}
    </StyledButton>
  );
};

Button.propTypes = {
  buttonRef: PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  }),
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  backgroundColor: PropTypes.string,
  backgroundColorOnHover: PropTypes.string,
  isTextOnly: PropTypes.bool,
  text: PropTypes.string,
  textColor: PropTypes.string,
  borderWidth: PropTypes.number,
  borderColor: PropTypes.string,
  style: PropTypes.shape({}),
  showHoverBg: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  buttonRef: undefined,
  disabled: false,
  type: 'button',
  backgroundColor: undefined,
  backgroundColorOnHover: ({ theme }) => theme.colors.defaultHover,
  isTextOnly: true,
  text: 'Button',
  textColor: undefined,
  borderWidth: 0,
  borderColor: 'transparent',
  showHoverBg: false,
  style: {},
  onClick: () => {},
};

const ButtonCSS = css`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 6px;
  padding: 0px 12px;
  cursor: pointer;
`;

const StyledButton = styled.button`
  ${ButtonCSS}
  ${TextCSS.FootnoteM}
  
  ${props => {
    const {
      disabled,
      backgroundColor,
      backgroundColorOnHover,
      textColor,
      borderWidth,
      borderColor,
      theme,
      showHoverBg,
    } = props;

    return css`
      background-color: ${backgroundColor || theme.colors.primary};
      color: ${textColor || theme.colors.ui_1};
      border: ${borderWidth}px solid ${borderColor};
      opacity: ${disabled ? 0.5 : 1};
      user-select: none;
      transition: background-color 0.1s, color 0.1s, border 0.1s;
      &:hover {
        background-color: ${backgroundColor === 'transparent' || showHoverBg
          ? backgroundColorOnHover
          : backgroundColor};
        opacity: ${backgroundColor === 'transparent' ? 0.9 : 1};
      }
    `;
  }}
`;

export default Button;
